// src/App.tsx
import { ThemeProvider } from 'styled-components';
import styled, { keyframes } from 'styled-components';
import GlobalStyle from './styles/globalStyles';
import { getTheme } from './styles/theme';
import { ThemeProviderContext, useTheme } from './context/ThemeContext';
import { QueryModalProvider } from './context/QueryModalContext';
import { ContactModalProvider } from './context/ContactModalContext';
import Navbar from './components/Navbar';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AboutPage from './components/about/AboutPage';
import Projects from './pages/Project';
import Extensions from './pages/Extensions';
import Contact from './pages/Contact';
import Query from './pages/Query';
import GetInTouch from './components/GetInTouch';
import WebDevelopment from './components/WebDevelopment';
import ResponsiveDesign from './components/ResponsiveDesign';
import FrontendDevelopment from './components/FrontendDevelopment';
import BackendDevelopment from './components/BackendDevelopment';
// import HireMe from './pages/HireMe';

const pageFadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const AppShell = styled.div`
  opacity: 0;
  animation: ${pageFadeIn} 240ms ease-out forwards;

  /* A route-level fade must not outlast the content reveals it sits in front
     of, and it is skipped entirely when the visitor has asked for less motion. */
  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 1;
  }
`;

const ThemedApp = () => {
  const { theme } = useTheme();

  useEffect(() => {
    // Page-level setup reserved; AOS removed in favor of lightweight CSS + IntersectionObserver
  }, []);

  // The registry resolves the mode, so this is the only place a theme is
  // selected and it has no idea which palettes exist. A new theme reaches the
  // whole site by being registered in styles/theme.ts, not by editing here.
  const activeTheme = getTheme(theme);

  return (
    <ThemeProvider theme={activeTheme}>
      <GlobalStyle />
      {/* Wraps the shell rather than sitting inside it so the single Query
          window is owned above every page. The Navbar and the Footer are
          siblings under the router, so this is the nearest common parent that
          can hand both of them the same open/close handlers. It lives inside
          ThemeProvider because ModalBox and QueryForm read theme tokens. */}
      <QueryModalProvider>
        {/* Same arrangement, same reason, for the Contact window. The two are
            separate providers because they are separate forms, but both sit
            inside ThemeProvider since ModalBox and both forms read theme
            tokens. */}
        <ContactModalProvider>
          <AppShell>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/extensions" element={<Extensions />} />
              <Route path="/contacts" element={<Contact />} />
              <Route path="/query" element={<Query />} />
              <Route path="/get-in-touch" element={<GetInTouch />} />
              <Route path="/view-my-work" element={<Projects />} />
              <Route path="/web-development" element={<WebDevelopment />} />
              <Route path="/frontend" element={<FrontendDevelopment />} />
              <Route path="/responsive-design" element={<ResponsiveDesign />} />
              <Route path="/backend-development" element={<BackendDevelopment />} />
            </Routes>
          </AppShell>
        </ContactModalProvider>
      </QueryModalProvider>
    </ThemeProvider>
  );
};

const App = () => (
  <Router>
    <ThemeProviderContext>
      <ThemedApp />
    </ThemeProviderContext>
  </Router>
);

export default App;
